import React from 'react'
import SubjectLegend from './SubjectLegend'
import SubjectVerticalBar from './SubjectVerticalBar'
import SubjectHorizontalBar from './SubjectHorizontalBar'
import getSubjectThresholdData from '../../../../helpers/assessment/getSubjectThresholdData';
import SubjectBar from './SubjectBar'
import forOwn from 'mout/object/forOwn'
import totalStudentThresholdCount from '../../../../helpers/assessment/totalStudentThresholdCount';
import sumArray from '../../../../helpers/sumArray';

export default function SubjectThreshold ({threshold, thresholdBreaks}) {
  let bars = []
  const data = getSubjectThresholdData(threshold, thresholdBreaks)

  forOwn(data, (ranges, subject) => {
    let percents = []
    const total = totalStudentThresholdCount(ranges)    
    ranges.forEach((range, n) => {
      if (n + 1 === ranges.length) {
        let roundedPercents = []
        percents.forEach((perc) => {
          roundedPercents.push(parseInt(Math.round(perc * 100), 10) / 100)
        })
        const sum = sumArray(roundedPercents)
        percents.push(1 - sum)
      } else {
        percents.push(range.count / total)
      }
    })
    bars.push(
      <SubjectBar 
        subject={subject} 
        percents={percents}
        key={`${subject}SubjectBar`} 
      />
    )
  })

  return (
    <div className="subject-scores">
      <h4>Subject Scores</h4>
      <h5>By Threshold</h5>
  		<div className="subject-scores-chart">
        <div className="barGraphs">
          {bars}
        </div>
        <SubjectLegend thresholdBreaks={thresholdBreaks} />
        <SubjectVerticalBar />
        <SubjectHorizontalBar />
      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/Threshold/SubjectThreshold.js